import angular from 'angular';
import _ from 'lodash';

(function() {
  'use strict';
  angular.module('app.core').factory('OrderDetails', OrderDetailsData);

  OrderDetailsData.$inject = ['ORDERS', 'OrderLine', 'OrderReduction'];

  /* @ngInject */
  function OrderDetailsData(ORDERS, OrderLine, OrderReduction) {
    OrderDetails.prototype = {
      build: build,
      getOrderNumberOrContract: getOrderNumberOrContract,
      getSellerName: getSellerName,
      getBuyerName: getBuyerName,
      getStatusColor: getStatusColor
    };

    function OrderDetails(orderDetailsData) {
      if (orderDetailsData) {
        this.build(orderDetailsData);
      }
    }

    return OrderDetails;

    /////////////////////

    function build(orderDetailsData) {
      this.guid = orderDetailsData.guid || null;
      this.orderNumber = orderDetailsData.orderNumber || null;
      this.contractNumber = orderDetailsData.contractNumber || null;
      this.creationDate = orderDetailsData.creationDate || null;
      this.updateDate = orderDetailsData.updatedDate || null;
      this.status = orderDetailsData.status || null;
      this.orderDate = orderDetailsData.valueDate || null;
      this.currency = orderDetailsData.currency || null;
      this.amountExcludingTaxes = orderDetailsData.amountExcludingTaxes;
      this.billedExclusiveTaxAmount = orderDetailsData.billedExclusiveTaxAmount;
      this.buyer = buildBuyer(orderDetailsData);
      this.idFiscalBuyer = orderDetailsData.idFiscalBuyer || null;
      this.idNationalBuyer = orderDetailsData.idNationalBuyer || null;
      this.deliveryAddress = buildDeliveryAddress(orderDetailsData);
      this.deliveryDate = orderDetailsData.deliveryDate || null;
      this.lines = _.map(orderDetailsData.lines, function(line) {
        return new OrderLine(line, orderDetailsData.updatedDate, orderDetailsData.type);
      });
      this.reductions = _.map(orderDetailsData.reductions, function(reduction) {
        return new OrderReduction(reduction);
      });
      this.costs = _.map(orderDetailsData.costs, function(cost) {
        return new OrderReduction(cost);
      });
      this.costAmount = orderDetailsData.costAmount;
      this.reductionAmount = orderDetailsData.reductionAmount;
      this.amountIncludingTaxes = orderDetailsData.amountIncludingTaxes;
      this.netPayable = orderDetailsData.netPayable;
      this.seller = buildSeller(orderDetailsData);
    }

    function buildBuyer(orderDetailsData) {
      let buyer = {};
      buyer.name = orderDetailsData.recipientName || null;
      buyer.buyerPerimeterCode = orderDetailsData.buyerPerimeterCode || null;
      if (orderDetailsData.buyer) {
        buyer.id = orderDetailsData.buyer.id || null;
        buyer.address = orderDetailsData.buyer.address || null;
        buyer.address2 = orderDetailsData.buyer.address2 || null;
        buyer.zipCode = orderDetailsData.buyer.zipCode || null;
        buyer.city = orderDetailsData.buyer.city || null;
        buyer.state = orderDetailsData.buyer.state || null;
        buyer.countryCode = orderDetailsData.buyer.countryCode || null;
      }
      return buyer;
    }

    function buildSeller(orderDetailsData) {
      let seller = {};
      seller.name = orderDetailsData.senderName || null;
      seller.idFiscal = orderDetailsData.idFiscalSeller || null;
      seller.idNational = orderDetailsData.idFiscalSeller || null;
      if (orderDetailsData.seller) {
        seller.address = orderDetailsData.seller.address || null;
        seller.address2 = orderDetailsData.seller.address2 || null;
        seller.zipCode = orderDetailsData.seller.zipCode || null;
        seller.city = orderDetailsData.seller.city || null;
        seller.state = orderDetailsData.seller.state || null;
        seller.countryCode = orderDetailsData.seller.countryCode || null;
      }
      return seller;
    }

    function buildDeliveryAddress(orderDetailsData) {
      let deliveryAddress = {};
      if (orderDetailsData.deliveryAddress) {
        deliveryAddress.name = orderDetailsData.deliveryAddress.name || null;
        deliveryAddress.address = orderDetailsData.deliveryAddress.address || null;
        deliveryAddress.address2 = orderDetailsData.deliveryAddress.address2 || null;
        deliveryAddress.zipCode = orderDetailsData.deliveryAddress.zipCode || null;
        deliveryAddress.city = orderDetailsData.deliveryAddress.city || null;
        deliveryAddress.state = orderDetailsData.deliveryAddress.state || null;
        deliveryAddress.countryCode = orderDetailsData.deliveryAddress.countryCode || null;
      }
      return deliveryAddress;
    }

    /**
     * Retourne le numéro de commande s'il existe, sinon le numéro de contrat.
     * Utilisé car une commande FullOrder de sub-type 'contract' n'a pas de numéro de commande.
     */
    function getOrderNumberOrContract() {
      return this.orderNumber || this.contractNumber;
    }

    /**
     * Fournit la raison sociale fournisseur + son idfiscal(national à défaut) entre parenthèse.
     */
    function getSellerName() {
      var idToDisplay = this.seller.idFiscal ? this.seller.idFiscal : this.seller.idNational;
      return this.seller.name + ' (' + idToDisplay + ')';
    }

    /**
     * Fournit la raison sociale client avec son éventuel périmètre  + son idfiscal(national à défaut) entre parenthèse.
     */
    function getBuyerName() {
      let idToDisplay = this.idFiscalBuyer ? this.idFiscalBuyer : this.idNationalBuyer;
      let perimeterCode = this.buyer.buyerPerimeterCode ? ' ' + this.buyer.buyerPerimeterCode + ' ' : '';
      return this.buyer.name + perimeterCode + ' (' + idToDisplay + ')';
    }

    /**
     * Récupère la couleur associée au statut.
     */
    function getStatusColor() {
      return _.result(_.find(ORDERS.status, { id: angular.lowercase(this.status) }), 'color');
    }
  }
})();
